<template>
  <ons-page id="episode"
    v-bind:class="{ 'page__content-ph-animate': initLoading }"
  >
    <app-bar :title="''" :enable-home="true" :enable-ticker="true" />
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-show="loading"></v-ons-progress-bar>
    <player-box :init-loading="initLoading" :episode-id="id" :episode="episode"/>
    <div class="container">
      <h1 class="episode-title ph-text" style="width: fit-content;" v-if="initLoading || !episode">■■■■■■■■ ■■■■■■■■ ■■■■■■■■</h1>
      <h1 class="episode-title" v-else>{{ episode && episode.title || title }}</h1>
    </div>
    <div class="bg-gradient pd-bottom" v-show="initLoading || isOffline || (episode && !!episode.description)">
      <section>
        <div class="container">
          <div style="display:none;" class="avatar-line"></div>
          <div class="container html">
            <p class="p ph-text" v-if="initLoading">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
            <div v-html="$sanitizeHTML(episode.description)" v-else-if="episode"></div>
            <p class="p" v-if="isOffline">{{ $t("episode.offline") }}</p>
          </div>
        </div>
      </section>
    </div>
    <div class="bg-gradient pd-bottom podcast-about">
      <section>
        <div class="avatar-line justify-row container">
          <div class="avatar avatar-podcast">
            <div class="avatar-border"></div>
            <a class="js-newpage" href=""
              @click.prevent=""
              v-if="initLoading || !episode || !episode.channel"
            > 
              <img class="round-sm" :src="constants.phImg70x70" alt="">
            </a> 
            <a class="js-newpage" href=""
              @click.prevent="navigatorPush('Channel', { id: episode.channel.id, title: episode.channel.title })"
              v-else
            > 
              <img-with-placeholder class="round-sm" :src="constants.phImg70x70" :data-src="sizeImg(episode.channel.image_base_url, 70, 70)" :alt="episode.channel.image.alt_text" />
            </a> 
          </div>
          <div class="main-item">
            <h2 class="name">
              <a class="js-newpage ph-text" href=""
                @click.prevent=""
                v-if="initLoading || !episode || !episode.channel"
              >
                ■■■■■■■■ ■■■■■■■■ ■■■■■■■■
              </a> 
              <a class="js-newpage" href=""
                @click.prevent="navigatorPush('Channel', { id: episode.channel.id, title: episode.channel.title })"
                v-else
              > 
                {{ episode.channel && episode.channel.title }}
              </a> 
            </h2>
            <div class="tools">
              <ons-button class="subscribe js-button-toggle btn-outline"
                modifier="small"
                v-bind:class="{ switched: episode && episode.channel && episode.channel.is_subscribed, 'ph-icon': initLoading }"
                :disabled="initLoading || subscribeLoading"
                @click="toggleSubscribe()"
              >
                <span class="icon-sm">
                  <icon-unsubscribe />
                </span>
                <span class="ph-text" v-if="initLoading">■■■■■■■■■■</span>
                <span class="txt" v-else>{{ (episode && episode.channel && episode.channel.is_subscribed) ? $t("channel.unsubscribe") : $t("channel.subscribe") }}</span>
              </ons-button>
              <ons-button class="" modifier="small quiet"
                v-if="episode.channel.private"
              >
                <span class="icon-sm">
                  <img src="@/assets/img/private.svg" alt="Private" width="30" height="30">
                </span>
              </ons-button>
            </div>
          </div>
        </div>
        <div class="container">
          <p class="p ph-text" v-if="initLoading">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
          <p class="p" v-else-if="episode && episode.channel">{{ (episode.channel.short_description || '') | truncate(200) }}</p>
          <p class="p ph-text" v-else-if="isOffline">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
        </div>
      </section>
    </div>
    <div class="bg-gradient pd-bottom ">
      <section>
        <div class="avatar-line justify-row container">
          <div class="avatar avatar-host">
            <div class="avatar-border"></div>
            <a class="js-newpage" @click.prevent="" href=""
              v-if="initLoading || !episode || !episode.channel || !episode.channel.host || !episode.channel.host.user"
            >
              <img class="round-max" :src="constants.phImg70x70" alt="">
            </a> 
            <a class="js-newpage" @click.prevent="navigatorPush('Host', { id: episode.channel.host.id, title: episode.channel.host.user.name })" href=""
              v-else
            >
              <img-with-placeholder class="round-max" :src="constants.phImg70x70" :data-src="sizeImg(episode.channel.host.user.avatar.base_url, 70, 70)" :alt="episode.channel.host.user.avatar.alt_text" />
            </a> 
          </div>
          <div class="main-item">
            <h2 class="name">
              <a class="js-newpage ph-text" @click.prevent="" href=""
                v-if="initLoading || !episode || !episode.channel || !episode.channel.host || !episode.channel.host.user"
              >■■■■■■■■■■■■■■■</a> 
              <a class="js-newpage" @click.prevent="navigatorPush('Host', { id: episode.channel.host.id, title: episode.channel.host.user.name })" href=""
                v-else
              >{{ episode.channel && episode.channel.host.user.name }}</a> 
            </h2>
            <div class="tools">
              <ons-button class="donate js-donate btn-outline" modifier="small"
                v-bind:class="{ 'ph-icon': initLoading }"
                :disabled="initLoading"
                v-if="false"
                @click="openDonateActionSheet()"
              >
                <span class="icon-sm">
                  <icon-donate />
                </span>
                <span class="txt">
                Donate
                </span>
              </ons-button>
              <span>&nbsp;</span>
              <ons-button class="follow js-button-toggle btn-outline"
                modifier="small"
                v-bind:class="{ switched: episode && episode.channel && episode.channel.host && episode.channel.host.is_following, 'ph-icon': initLoading }"
                :disabled="initLoading || followLoading"
                @click="toggleFollow()"
              >
                <span class="icon-sm">
                  <icon-follow />
                </span>
                <span class="txt">{{ (episode && episode.channel && episode.channel.host && episode.channel.host.is_following) ? $t("host.unfollow") : $t("host.follow") }}</span>
              </ons-button>
            </div>
          </div>
        </div>
        <div class="container">
          <p class="p ph-text" v-if="initLoading">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
          <p class="p" v-else-if="episode && episode.channel && episode.channel.host">{{ episode.channel && episode.channel.host.description }}</p>
          <p class="p ph-text" v-else-if="isOffline">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
        </div>
      </section>
    </div>
    <section class="pd-both container" v-show="!initLoading && episode && episode.recommended_episodes && Array.isArray(episode.recommended_episodes) && episode.recommended_episodes.length">
      <h2 class="row-title1">{{ $t("episode.recommended_episodes") }}</h2>
      <episode-grid :episodes="episode && episode.recommended_episodes" />
    </section>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_for_details") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
    <float-player class="player-iphonex-apply-bottom-notch" v-if="!!playerMediumUrl && id !== playerEpisodeId" />
    <float-player class="player-iphonex-apply-bottom-notch" :image-url="!episode ? null : episode.image ? episode.image_base_url : episode.channel.image_base_url" :on-play-or-pause="playOrPauseWrapper" :on-close="close" :could-show="!floatPlayerClosed && showTopFloatPlayer && !initLoading" v-show="!floatPlayerClosed && showTopFloatPlayer && !initLoading" v-else />
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';
import EpisodeGrid from '@/components/EpisodeGrid.vue';
import FloatPlayer from '@/components/FloatPlayer.vue';
import PlayerBox from '@/components/PlayerBox.vue';
import Episode from '@/models/Episode';
import PlayerHelper from '@/mixins/PlayerHelper';
import WatchUserChangeHelper from '@/mixins/WatchUserChangeHelper';

export default {
  name: 'episode',
  props: ['id', 'title', 'skipAutoPlay'],
  components: {
    'app-bar': AppBar,
    'episode-grid': EpisodeGrid,
    'float-player': FloatPlayer,
    'player-box': PlayerBox,
  },
  mixins: [PlayerHelper, WatchUserChangeHelper],

  data() {
    return {
      initLoading: true,
      loading: true,
      subscribeLoading: false,
      followLoading: false,
      pageContent: null,
      showTopFloatPlayer: false,
      floatPlayerClosed: false,
      onScrollFn: null,
      ticking: false,
    };
  },

  computed: {
    episode() {
      return Episode.query().whereId(this.id).with('channel.host.user').with('recommended_episodes.channel').first();
    },
    playerMediumUrl() {
      return this.$store.state.player.mediumUrl;
    },
    playerEpisodeId() {
      return this.$store.state.player.episodeId;
    },
  },

  methods: {
    toggleSubscribe() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_sub"))) { return; }
      let that = this;
      this.loading = true;
      this.subscribeLoading = true;
      this.episode.channel.toggleSubscribe(this.currentUser.id)
        .then(() => {
          this.currentUser.updateSubscriptionsChanged(true);
        }).catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.subscribeLoading = false;
          if (this.episode.channel.is_subscribed) { this.askPushNotification(); }
        });
    },
    toggleFollow() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_follow"))) { return; }
      let that = this;
      this.loading = true;
      this.followLoading = true;
      this.episode.channel.host.toggleFollow(this.currentUser.id)
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.followLoading = false;
        });
    },
    playOrPauseWrapper(skipEpisodeCheck = false) {
      this.playOrPause(this.episode, this.episode.channel, skipEpisodeCheck);
    },
    close() {
      this.floatPlayerClosed = true;
    },
    onUserChanged() {
      let that = this;
      this.loading = true;
      Episode.fetchById(this.id)
        .catch(function (error) {
          console.log(error);
          if (that.isOffline) { return; }
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    let that = this;
    this.initLoading = true;
    this.loading = true;
    Episode.fetchById(this.id)
      .then((_episode) => {
        if (!that.skipAutoPlay && that.currentUser.auto_play_enabled) {
          that.playOrPauseWrapper();
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          that.navigatorResetLogin(that.$t("messages.login_required"));
        } else {
          console.log(error);
          if (that.isOffline) { return; }
          that.showSomethingWrongToast();
        }
      }).finally(() => {
        this.initLoading = false;
        this.loading = false;
        this.$ga.query('send', 'pageview', this.$route.path, {
          'dimension3': this.episode && this.episode.channel && this.episode.channel.id,
          'dimension4': this.episode && this.episode.channel && this.episode.channel.host && this.episode.channel.host.id
        });
      });
  },

  mounted() {
    // show/hide top player on scroll
    let component = this;
    let page = component.$el;
    this.pageContent = page.querySelector('.page__content');
    let podcastAbout = page.querySelector('.podcast-about');

    const { raf } = window;

    this.onScrollFn = (e) => {
      let pos = podcastAbout.getBoundingClientRect().top;
  
      if (!component.ticking) {
        component.ticking = true;
        raf(() => {
          if (pos <= 44) {
            component.showTopFloatPlayer = true;
          } else {
            component.showTopFloatPlayer = false;
          }
          component.ticking = false;
        });
      }
    };

    this.pageContent.addEventListener('scroll', this.onScrollFn);
  },
};
</script>
